export default __webpack_public_path__ + "static/media/freestyle-libre-logo.1372c507.png";